import React from 'react';
import {createUseStyles} from 'react-jss';
import clsx from 'clsx';

const useStyles = createUseStyles({
  dataLoaderWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.4)',
    zIndex: 1,
    '&.hidden': {
      display: 'none'
    }
  },
  dataLoader: {
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 20px)',
    width: 40,
    height: 40,
    border: '2px solid rgba(255, 255, 255, 0.2)',
    borderTop: '2px solid #004ba4',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  '@keyframes spin': {
    from: {transform: 'rotate(0deg)'},
    to: {transform: 'rotate(360deg)'}
  }
});

export const Loader = ({visibility}) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.dataLoaderWrapper, {hidden: !visibility})}>
      <div className={classes.dataLoader} />
    </div>
  );
};

